import { Box } from "@components/core/Box";
import { useTranslation } from "next-i18next";
import { Key, Wrapper } from "./Shortcuts.style";

const Shortcuts: React.FC = () => {
	const { t } = useTranslation("translation");
	return (
		<Wrapper>
			<Box p="0" direction="row" width="100">
				<Box size="large" width="50" p="8">
					{t("Shortcuts.TogglePlayPause")}
				</Box>
				<Box
					size="large"
					width="50"
					direction="row"
					justifyContent="start"
					p="8"
				>
					<Key>P</Key> {t("Or")} <Key>SPACE</Key>
				</Box>
			</Box>

			<Box p="0" direction="row" width="100">
				<Box size="large" width="50" p="8">
					{t("Shortcuts.PreviousTrack")}
				</Box>
				<Box
					size="large"
					width="50"
					direction="row"
					justifyContent="start"
					p="8"
				>
					<Key>{t("Shortcuts.LeftArrow").toUpperCase()}</Key>
				</Box>
			</Box>
			<Box p="0" direction="row" width="100">
				<Box size="large" width="50" p="8">
					{t("Shortcuts.NextTrack")}
				</Box>
				<Box
					size="large"
					width="50"
					direction="row"
					justifyContent="start"
					p="8"
				>
					<Key>{t("Shortcuts.RightArrow").toUpperCase()}</Key>
				</Box>
			</Box>
			<Box p="0" direction="row" width="100">
				<Box size="large" width="50" p="8">
					{t("Shortcuts.SeekForwards")}
				</Box>
				<Box
					size="large"
					width="50"
					direction="row"
					justifyContent="start"
					p="8"
				>
					<Key>&gt;</Key> {t("Or")} <Key>.</Key>
				</Box>
			</Box>
			<Box p="0" direction="row" width="100">
				<Box size="large" width="50" p="8">
					{t("Shortcuts.SeekBackwards")}
				</Box>
				<Box
					size="large"
					width="50"
					direction="row"
					justifyContent="start"
					p="8"
				>
					<Key>&lt;</Key> {t("Or")} <Key>,</Key>
				</Box>
			</Box>
			<Box p="0" direction="row" width="100">
				<Box size="large" width="50" p="8">
					{t("Shortcuts.ToggleWaveformZoom")}
				</Box>
				<Box
					size="large"
					width="50"
					direction="row"
					justifyContent="start"
					p="8"
				>
					<Key>Z</Key>
				</Box>
			</Box>
			<Box p="0" direction="row" width="100">
				<Box size="large" width="50" p="8">
					{t("Shortcuts.AddTrackToShoppingCart")}
				</Box>
				<Box
					size="large"
					width="50"
					direction="row"
					justifyContent="start"
					p="8"
				>
					<Key>B</Key> {t("Or")} <Key>+</Key> {t("Or")} <Key>=</Key>
				</Box>
			</Box>
			<Box p="0" direction="row" width="100">
				<Box size="large" width="50" p="8">
					{t("Shortcuts.ToggleOpenPlaylist")}
				</Box>
				<Box
					size="large"
					width="50"
					direction="row"
					justifyContent="start"
					p="8"
				>
					<Key>O</Key> {t("Or")} <Key>I</Key>
				</Box>
			</Box>
			<Box p="0" direction="row" width="100">
				<Box size="large" width="50" p="8">
					{t("Shortcuts.ToggleShortcuts")}
				</Box>
				<Box
					size="large"
					width="50"
					direction="row"
					justifyContent="start"
					p="8"
				>
					<Key>?</Key>
				</Box>
			</Box>
		</Wrapper>
	);
};

export default Shortcuts;
